"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const federatedApp_1 = __importDefault(require("helpers/federatedApp"));
const APP_LIST = {
    app_audience: () => Promise.resolve().then(() => __importStar(require('app-audience-mf/PromoteProduct'))).then(({ default: render }) => render)
};
class AudiencePromoteProductUtils {
}
_a = AudiencePromoteProductUtils;
AudiencePromoteProductUtils.renderAsModuleFederation = async (root, options) => {
    const render = await federatedApp_1.default.getRenderFederatedApp('app_audience', './PromoteProduct', APP_LIST);
    if (render) {
        const { onClose, language, showModal, token, user, activationSource, productId, filters, subdomain } = options;
        const base64Filters = filters && Buffer.from(JSON.stringify(filters)).toString('base64');
        const params = {
            subdomain,
            product_id: productId,
            filters: base64Filters
        };
        const props = {
            componentProps: {
                modalType: 'promote_send_campaigns',
                container: '.hotmart-product-root',
                open: showModal,
                onclose: onClose,
                activationSource,
                params
            },
            user,
            language,
            token
        };
        render({ root, props });
    }
};
exports.default = AudiencePromoteProductUtils;
